module.exports = __webpack_public_path__ + "img/aviation.e28a1e83.jpg";